// Wrapper for creating form data to upload images to the CMS
export const createImageFormData = async (image: string, fileName: string) => {
  const formData = new FormData()
  const blob = await fetch(image).then(r => r.blob())
  const ext = blob.type.split('/')[1]
  formData.append('file', blob, `${fileName}.${ext}`)
  return formData
}